// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"61409827a75d1af7","309":"ef58f8ebfdbe6bed"}[chunkId] + ".js";
};